export default {
  usersBlacklist: {
    '5af45b4cdd18f0d2026e8d26': 1, //GaySideStories
    '5abc13f9f2a46ebc0b477d9a': 1, //Les Nébuleuses
  },
  mimeTypes: {
    audio: ['audio/mp3', 'audio/mpeg', 'audio/m4a', 'audio/x-m4a'],
    image: ['image/jpeg', 'image/png'],
  },
  env: process.env.ENV,
  appEnv: process.env.APP_ENV,
  version: process.env.APP_VERSION,
  baseUrl: process.env.baseUrl,
  feedUrl: process.env.feedUrl,
  feederBaseUrl: process.env.feederBaseUrl,
  embedPlayerUrl: process.env.embedPlayerUrl,
  showsUrl: process.env.showsUrl,
  corporateUrl: process.env.corporateUrl,
  insightsBaseUrl: process.env.insightsBaseUrl,
  insightsApiBaseUrl: process.env.insightsApiBaseUrl,
  waveformUrl: process.env.waveformUrl,
  s3Bucket: process.env.s3Bucket,
  snipS3Bucket: process.env.snipS3Bucket,
  awsRegion: process.env.awsRegion,
  awsUploadAccessKeyId: process.env.awsUploadAccessKeyId,
  googleFontApiKey: process.env.googleFontApiKey,
  rawStaticCDN: process.env.staticCDN,
  staticCDN:
    process.env.ENV === 'local'
      ? process.env.staticCDN + '/app'
      : process.env.staticCDN + '/app/' + process.env.APP_VERSION,
  intercomAppId: process.env.intercomAppId,
  defaultCover: `${process.env.staticCDN}/global/images/default-cover.png`,
  sphinxEncoder: process.env.SPHINX_ENCODER,
  acastPlusManagerAppUrl: process.env.PLUS_MANAGER_URL,
  crowdinBaseUrl: process.env.CROWDIN_BASE_URL,
  podcastleAuthUrl: process.env.podcastleAuthUrl,
  goptOnboardingExperiment: process.env.G_OPT_ONBOARDING_EXPERIMENT,
  mixpanelToken: process.env.MIXPANEL_TOKEN,
  mixpanelReplayShowId: process.env.MIXPANEL_REPLAY_SHOW_ID,
  standardCreatorTermsAndConditions: process.env.standardCreatorTermsAndConditions,
  customCreatorTermsAndConditions: process.env.customCreatorTermsAndConditions,
  googleCaptchaSiteKey: process.env.GOOGLE_CAPTCHA_SITE_KEY,
  cmsImageTransformDomain: process.env.CMS_IMAGE_TRANSFORM_DOMAIN,
  phyllo: {
    environment: process.env.PHYLLO_ENV,
    platforms: {
      facebook: process.env.PHYLLO_FACEBOOK_PLATFORM,
      instagram: process.env.PHYLLO_INSTAGRAM_PLATFORM,
      tiktok: process.env.PHYLLO_TIKTOK_PLATFORM,
      youtube: process.env.PHYLLO_YOUTUBE_PLATFORM,
    },
  },
  transcriptUrl: process.env.transcriptUrl,
};
